<template>
  <div ref="container">
    <a-modal :title="title" :width="600" :visible="visible" :confirmLoading="confirmLoading"
             :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}"
             :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk"
             @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          关闭
        </a-button>
        <a-button type="primary" @click="handleOk">
          保存
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-form-model ref="form" :model="model" name="basic" :rules="rules">
          <a-row class="form-row">
            <a-col>
              <a-form-model-item :labelCol="labelCol" name="supplier" :wrapperCol="wrapperCol" label="名称"
                                 prop="supplier">
                <a-input placeholder="请输入名称" v-model="model.supplier" />
              </a-form-model-item>
            </a-col>
            <a-col>
              <a-form-model-item :labelCol="labelCol" name="orgaId" :wrapperCol="wrapperCol" label="类型" prop="orgaId">
                <!-- <a-tree-select style="width:100%" @change='onChangeData' :dropdownStyle="{maxHeight:'200px',overflow:'auto'}" allow-clear :treeData="orgaTree" v-model="model.orgName" :replaceFields="{title:'title',value:'id',children:'children', key: 'key',}" placeholder="请选择类型">
                </a-tree-select> -->
                <a-select placeholder="选择类型" v-model="model.orgaId" @change="onChangeData">
                  <a-select-option v-for="(item,index) in typeList" :key="item.id" :value="item.id.toString()">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col v-if="model.orgaId>1">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级名称" prop="parentName">
                <a-select allowClear mode="multiple" placeholder="选择上级名称" v-model:value="model.parentName">
                  <a-select-option v-for="(item,index) in userList" :key="item.id" :value="item.id.toString()">
                    {{ item.supplier }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <addresslist ref="addresslist" v-if="visible" v-model="model.addressList"></addresslist>
            <a-col>
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
                <a-textarea placeholder="请输入备注" v-model="model.description" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { pinyin } from 'pinyin-pro'

import pick from 'lodash.pick'
import {
  addSupplier,
  editSupplier,
  addUser,
  addUserNew,
  checkSupplier,
  queryOrganizationTreeList,
  getParentApi,
  getUserlList
} from '@/api/api'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Shengshixian from '@comp/shengshixian.vue'
import addresslist from '@comp/addresslist.vue'

export default {
  name: 'CustomerModal',
  components: { Shengshixian,addresslist },
  mixins: [mixinDevice, JeecgListMixin],
  data () {
    return {
      title: '操作',
      orgaTree: [],
      userList: [],
      visible: false,
      model: {},
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      typeList: [
        {
          name: '一级经销商',
          id: 1
        },
        {
          name: '二级经销商',
          id: 2
        },
        {
          name: '三级经销商',
          id: 3
        }
      ],
      confirmLoading: false,
      rules: {
        supplier: [
          { required: true, message: '请输入名称!' },
          { min: 2, max: 60, message: '长度在 2 到 60 个字符', trigger: 'blur' },
          { validator: this.validateSupplierName }
        ],
        orgaId: [{ required: true, message: '请选择类型!' }],
        parentName: [{ required: true, message: '请选择上级名称!' }]
      }
    }
  },
  created () {
  },
  methods: {
    async onChangeData () {
      if (this.model.parentName && this.model.parentName.length > 0) {
        this.model.parentName = []
      }

      this.getTypeList()
    },
    async getTypeList () {
      let params = {
        search: {
          supplier: '',
          type: '经销商',
          telephone: '',
          phonenum: '',
          orgaId: this.model.orgaId > 1 ? this.model.orgaId - 1 : '',
          userId: this.$store.getters.userInfo.id
        },
        currentPage: 1,
        pageSize: 9999
      }
      const res = await getParentApi(params)
      if (res.code == 200) {
        this.userList = res.data.rows
        this.confirmLoading = false
      } else {
        this.$message.error(res.data.message)
        // this.confirmLoading = false
      }
    },
    // 递归查询当前父节点
    // getParent(arr, id) {
    //   // console.log('执行了递归123')
    //   console.log(arr, id, '数据')
    //   for (let it of arr) {
    //     if (it.children && it.children.some((it) => it.id == id)) {
    //       return it.id
    //     }
    //     if (it.children) {
    //       let parentId = this.getParent(it.children, id)
    //       if (parentId != null) {
    //         return parentId
    //       }
    //     }
    //   }
    // },
    // loadOrgaData() {
    //   let this = this
    //   let params = {}
    //   params.id = ''
    //   queryOrganizationTreeList(params).then((res) => {
    //     if (res) {
    //       console.log(res, 'res___')
    //       this.orgaTree = res
    //       console.log(this.orgaTree, 'this.orgaTree')
    //     }
    //   })
    // },
    add () {
      this.edit({
        addressList:[]
      })
    },
    edit (record) {
      this.userList = []
      this.visible = true
      if (this.$refs.form !== undefined) this.$refs.form.resetFields()
      this.confirmLoading = true
      // let params = {}
      // params.id = ''
      this.model = Object.assign({}, record)
      console.log(this.model, 'model')
      if (record.parentId) {
        this.model.parentName = record.parentId.split(',')
        console.log(this.model.parentName, 'this.model.parentName')
      } else {
      }
      if (record.id) {
        // console.log('执行了')
        this.getTypeList()
      } else {
        this.confirmLoading = false
      }
      // queryOrganizationTreeList(params).then((res) => {
      //   if (res) {
      //     console.log(res, 'res___')
      //     // this.orgaTree = res
      //     // console.log(this.orgaTree, 'this.orgaTree')
      //     console.log(record, 'record')
      //     this.model = Object.assign({}, record)
      //     // console.log(this.model, 'this.model')

      //   } else {
      //     this.confirmLoading = false
      //   }
      // })
    },
    close () {
      console.log('执行了close')
      this.$emit('ok')
      this.visible = false
      this.confirmLoading = false
    },
    handleOk () {
      this.$refs.addresslist.save()
      console.log(this.model, 'this.model')
      this.$refs['form'].validate((success) => {
        if (success === true) {
          this.confirmLoading = true
          let formData = Object.assign(this.model)
          // let formData = this.model

          formData.type = '经销商'
          console.log(this.model, 'model')
          console.log(typeof this.model.parentName, '111')
          if (this.model.parentName && this.model.parentName.length != 0) {
            formData.parentId = this.model.parentName.toString()
          } else {
            delete formData.parentName
            // formData.parentId = ''
          }
          if (this.model.orgaId == 1) {
            delete formData.parentId
            delete formData.parentName
          }
          console.log(formData, 'formData')
          // return
          // if()
          let obj
          if (!this.model.id) {
            obj = addSupplier(formData)
          } else {
            obj = editSupplier(formData)
          }
          console.log(obj, 'obj')

          obj
            .then(async (res) => {
              if (res.code === 200) {
                console.log(res, 'res123')
                console.log(this.model.id, 'this.model.id')
                return

                if (this.model.id != undefined || this.model.id) return this.close()
                console.log(formData.supplier, 'formData.supplier')
                let params = {
                  search: {
                    supplier: formData.supplier,
                    type: '经销商',
                    telephone: '',
                    phonenum: '',
                    userId: this.$store.getters.userInfo.id
                  },
                  column: 'createTime',
                  order: 'desc',
                  field:
                    'id,,,action,supplier,parentName,orgName,isOpenTransshipment,locationName,levelRegulation,enabled',
                  currentPage: 1,
                  pageSize: 10
                }
                let obj = {}
                const result = await getUserlList(params)
                console.log(result, 'result')
                if (result.code == 200 && result.data.rows.length > 0) {
                  // obj = result.data.rows[0]
                  // 转成拼音首拼
                  var reg = /[^\x00-\xff]/g
                  obj.loginName = pinyin(result.data.rows[0].supplier, {
                    pattern: 'first',
                    type: 'array',
                    toneType: 'none'
                  })
                    .toString()
                    .replace(/,/g, '')
                    .replace(reg, '')
                    .replace(')', '')
                    .replace('(', '')
                  obj.username = result.data.rows[0].supplier
                  obj.id = result.data.rows[0].id
                  obj.roleId = 22
                  console.log(obj, 'obj------')
                  // delete obj.tenantId
                  // delete obj.id
                  const data = await addUserNew(obj)
                  console.log(data, 'data')
                  if (data.code == 200) {
                    this.close()
                  } else {
                    this.$message.warning(data.data.message || data.data)
                  }
                } else {
                  this.$message.warning(result.data.message || result.data)
                }
              } else {
                this.$message.warning(res.data.message || res.data)
              }
            })
            .finally(() => {
              this.confirmLoading = false
              this.close()
            })
        }
      })
      // const this = this
      // // 触发表单验证
      // this.$refs.form.validateFields((err, values) => {
      //   console.log(err, 'err')
      //   if (!err) {

      //   }
      // })
    },
    handleCancel () {
      this.close()
    },
    validateSupplierName (rule, value, callback) {
      let params = {
        name: value,
        type: '客户',
        id: this.model.id ? this.model.id : 0
      }
      checkSupplier(params).then((res) => {
        if (res && res.code === 200) {
          if (!res.data.status) {
            callback()
          } else {
            callback('名称已经存在')
          }
        } else {
          callback(res.data)
        }
      })
    }
  }
}
</script>
<style scoped>
</style>